jQuery(function ($) {
    var paged = 1;

    $('.loadmore').on('click', function () {
        paged++;

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'events_load_more',
                paged: paged,
            },
            beforeSend: function () {
                $('.loadmore span').text('Laddar...');
            },
            success: function (res) {
                if (paged > res.max) {
                    $('.loadmore').hide();
                }

                $(res.html).hide().appendTo('.past-events .eventon_events_list').fadeIn(500);

            },
            complete: function () {
                $('.loadmore span').text('Ladda fler');
            }
        });
    });
});